/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.home-breast__slider');

if( slider ) {
    var splide = new Splide( '.home-breast__slider' , {
        type: 'slider',
        speed: 1000,
        arrows: true,
        pagination: false,
        rewind: false,
        start: 1,
        perPage: 3,
        perMove: 1,
        gap: 0,
        focus  : 'center',
        drag: true,
        arrowPath: 'M.054,0,0,.047,11.86,18.44.027,36.85l18.6-16.122,2.639-2.288-2.639-2.295Z',
        breakpoints: {
            960: {
                perPage: 1
            },
        }
    });
    splide.mount();
}